import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, CanMatchFn, GuardResult, MaybeAsync, Route, Router, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { map } from 'rxjs';
import { checkLogin } from '../utils/auth.helper';

export const authGuard: CanActivateFn & CanActivateChildFn & CanMatchFn = authGuardInternal;

function authGuardInternal(route: ActivatedRouteSnapshot | Route, state: RouterStateSnapshot | UrlSegment[]): MaybeAsync<GuardResult> {
  const msalService = inject(MsalService);
  const msalBroadcastService = inject(MsalBroadcastService);
  const router = inject(Router);

  return checkLogin(msalService, msalBroadcastService).pipe(
    map(result => result || router.parseUrl(''))
  );
}
